import { ReactComponent as CalendarIcon } from '../../../../../assets/icons/no_exchange_time.svg';
import { useLocale } from '../../../../../context/NbLocalizationContext';
import classes from './OrderCurrencyExchangeUnavailable.module.scss';

export const OrderCurrencyExchangeUnavailable = () => {
  const { translation } = useLocale();
  const t = translation.orderModal;

  return (
    <div
      data-testid="order-currency-exchange-unavailable"
      className={classes.container}
    >
      <CalendarIcon className={classes.icon} />
      <span className={classes.title}>{t.exchangeNotes.currentlyNoExchangePeriod}</span>
      <div className={classes.scheduleContainer}>
        <span className={classes.subtitle}>{t.exchangeNotes.tryLaterFixTime}</span>
        <span className={classes.schedule}>{t.currencyExchangeForm.unavailableSchedule}</span>
      </div>
    </div>
  );
};
